import React from 'react'
import {
  makeStyles,
  Card,
  CardContent,
  Grid,
  // TextField,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Link,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'
import {
  CloudUpload as CloudUploadIcon,
  Attachment as AttachmentIcon,
  ErrorOutline as ErrorOutlineIcon,
} from '@material-ui/icons'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'
import { orange } from '@material-ui/core/colors'
import {
  withStyles,
} from '@material-ui/core/styles'
import { addScholarship } from '../../../app/slices/scholarshipSlice'
import { selectorLoading } from '../../../app/slices/loadingSlice'
// import { IMAGE_BASE_URL } from '../../../api/index'
import { CssTextField } from '../../../utils/CustomInputs'

const OrangeRadio = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />)

const statusType = {
  REVIEWER: 'reviewer',
  USER: 'user',
}

const files = [
  { id: 'inventionFile', disabled: 'hasInvention', label: 'ابداع یا اختراع (فایل ویدیویی یا تصویری)' },
  { id: 'rankFile', disabled: 'hasRank', label: 'فایل رتبه المپیاد یا رتبه علمی' },
  { id: 'birthCertificateFile', disabled: 'hasBirthCertificate', label: 'تصویر صفحه اول شناسنامه' },
  { id: 'achievementFile', disabled: 'hasAchievement', label: 'فایل آثار یا دستاورد' },
  { id: 'obtainedPositionFile', disabled: 'hasObtainedPosition', label: 'فایل مدرک مقام کسب شده' },
]

const useStyle = makeStyles((theme) => ({
  root: {},
  item: {
    height: theme.spacing(13),
    padding: theme.spacing(1.5),
  },
  extraHeight: {
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing(16),
    },
  },
  itemMultiline: {
    padding: theme.spacing(1.5),
    height: theme.spacing(20),
  },
  uploadItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 11, 1.5, 1.5),
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 3, 1.5, 1.5),
    },
  },
  inputFile: {
    display: 'none',
  },
  uploadLabel: {
    fontWeight: 700,
  },
  uploadAttachment: {
    width: theme.spacing(3),
    position: 'absolute',
    right: theme.spacing(6),
    '& svg': {
      verticalAlign: 'middle',
    },
    [theme.breakpoints.down('xs')]: {
      right: theme.spacing(0),
    },
  },
  uploadButton: {
    width: theme.spacing(25),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(17),
    },
  },
  link: {

  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3rem',
  },
  buttonSend: {
    width: theme.spacing(20),
  },
}))

const validationSchema = yup.object({
  talent: yup
    .string('لطفا نوع استعداد خود را وارد کنید')
    .required('نوع استعداد الزامی است.'),
  activityField: yup
    .string('لطفا رشته فعالیت خود را وارد کنید')
    .required('رشته فعالیت الزامی است.'),
  activityOnsetAge: yup
    .string('سن شروع فعالیت خود را وارد کنید.')
    .required('سن شروع فعالیت الزامی است'),
  activityDuration: yup
    .string('مدت زمان فعالیت خود را وارد کنید.')
    .required('مدت زمان فعالیت الزامی است'),
  reason: yup
    .string('دلیل درخواست برای بورس را وارد کنید.')
    .required('دلیل درخواست بورس الزامی است'),
  inventionFile: yup
    .mixed().when('hasInvention', {
      is: '1',
      then: yup.mixed().required(),
    }),
  rankFile: yup
    .mixed().when('hasRank', {
      is: '1',
      then: yup.mixed().required(),
    }),
  achievementFile: yup
    .mixed().when('hasAchievement', {
      is: '1',
      then: yup.mixed().required(),
    }),
  birthCertificateFile: yup
    .mixed().required(),
  obtainedPositionFile: yup
    .mixed().required(),
})

const FormStep = () => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const loading = useSelector(selectorLoading)
  const location = useLocation()
  const scholarshipInfo = useSelector((state) => state.scholarship.current)
  const [status, setStatus] = React.useState(null)

  const formik = useFormik({
    initialValues: {
      talent: scholarshipInfo?.talent || '',
      activityField: scholarshipInfo?.activityField || '',
      activityOnsetAge: scholarshipInfo?.activityOnsetAge || '',
      activityDuration: scholarshipInfo?.activityDuration || '',
      hasInvention: Number(scholarshipInfo?.hasInvention)
        ? Number(scholarshipInfo?.hasInvention).toString() : '0',
      hasRank: Number(scholarshipInfo?.hasRank)
        ? Number(scholarshipInfo?.hasRank).toString() : '0',
      hasAchievement: Number(scholarshipInfo?.hasAchievement)
        ? Number(scholarshipInfo?.hasAchievement).toString() : '0',
      hasCoach: Number(scholarshipInfo?.hasCoach)
        ? Number(scholarshipInfo?.hasCoach).toString() : '0',
      hasBirthCertificate: '1',
      hasObtainedPosition: '1',
      obtainedPosition: Number(scholarshipInfo?.obtainedPosition)
        ? Number(scholarshipInfo?.obtainedPosition).toString() : '1',
      reason: scholarshipInfo?.reason || '',
      hasInstituteSupport: Number(scholarshipInfo?.hasInstituteSupport)
        ? Number(scholarshipInfo?.hasInstituteSupport).toString() : '0',
      hasOrganizationalSupport: Number(scholarshipInfo?.hasOrganizationalSupport)
        ? Number(scholarshipInfo?.hasOrganizationalSupport).toString() : '0',
      description: scholarshipInfo?.description || '',
      achievementFile: scholarshipInfo?.achievementFile?.url || null,
      birthCertificateFile: scholarshipInfo?.birthCertificateFile?.url || null,
      inventionFile: scholarshipInfo?.inventionFile?.url || null,
      obtainedPositionFile: scholarshipInfo?.obtainedPositionFile?.url || null,
      rankFile: scholarshipInfo?.rankFile || null,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: ({
      talent, activityField, activityDuration,
      achievementFile, activityOnsetAge,
      birthCertificateFile, hasRank,
      inventionFile, reason, hasInvention,
      obtainedPositionFile, hasCoach,
      rankFile, hasAchievement, obtainedPosition,
    }) => {
      const scholarship = {
        talent,
        activityField,
        activityOnsetAge: activityOnsetAge ? Number(activityOnsetAge) : null,
        activityDuration,
        hasInvention: !!Number(hasInvention),
        hasRank: !!Number(hasRank),
        hasAchievement: !!Number(hasAchievement),
        hasCoach: !!Number(hasCoach),
        obtainedPosition: obtainedPosition ? Number(obtainedPosition) : null,
        reason,
      }
      const formData = new FormData()
      formData.append('scholarship', JSON.stringify(scholarship))
      if (Number(hasAchievement)) formData.append('achievementFile', achievementFile)
      formData.append('birthCertificateFile', birthCertificateFile)
      if (Number(hasInvention)) formData.append('inventionFile', inventionFile)
      formData.append('obtainedPositionFile', obtainedPositionFile)
      if (Number(hasRank)) formData.append('rankFile', rankFile)
      dispatch(addScholarship(formData))
    },
  })

  React.useEffect(() => {
    if (location.pathname.includes('/review/')) {
      setStatus(statusType.REVIEWER)
    } else {
      setStatus(statusType.USER)
    }
  }, [scholarshipInfo])

  console.log(scholarshipInfo?.inventionFile?.url, 'bdgdh')

  return (
    <form onSubmit={formik.handleSubmit}>
      <Card className={classes.root}>
        <CardContent>
          <Grid container>
            <Grid item xs={12} sm={6} classes={{ root: classes.item }}>
              <CssTextField
                fullWidth
                variant="outlined"
                name="talent"
                label="نوع استعداد"
                type="text"
                value={formik.values.talent}
                onChange={formik.handleChange}
                error={formik.touched.talent && Boolean(formik.errors.talent)}
                helperText={formik.touched.talent && formik.errors.talent}
                disabled={status === statusType.REVIEWER}
                inputProps={{
                  style: { color: status === statusType.REVIEWER && '#000' },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} classes={{ root: classes.item }}>
              <CssTextField
                fullWidth
                variant="outlined"
                name="activityField"
                label="حوزه یا رشته فعالیت"
                type="text"
                value={formik.values.activityField}
                onChange={formik.handleChange}
                error={formik.touched.activityField && Boolean(formik.errors.activityField)}
                helperText={formik.touched.activityField && formik.errors.activityField}
                disabled={status === statusType.REVIEWER}
                inputProps={{
                  style: { color: status === statusType.REVIEWER && '#000' },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} classes={{ root: classes.item }}>
              <CssTextField
                fullWidth
                variant="outlined"
                name="activityOnsetAge"
                label="سن شروع به فعالیت"
                type="text"
                value={formik.values.activityOnsetAge}
                onChange={(e) => (e.target.validity.valid ? formik.handleChange(e) : null)}
                error={formik.touched.activityOnsetAge && Boolean(formik.errors.activityOnsetAge)}
                helperText={formik.touched.activityOnsetAge && formik.errors.activityOnsetAge}
                inputProps={{
                  pattern: '[0-9]*',
                  style: { color: status === statusType.REVIEWER && '#000' },
                }}
                disabled={status === statusType.REVIEWER}
              />
            </Grid>
            <Grid item xs={12} sm={6} classes={{ root: classes.item }}>
              <CssTextField
                fullWidth
                variant="outlined"
                name="activityDuration"
                label="مدت زمان فعالیت"
                type="text"
                value={formik.values.activityDuration}
                onChange={formik.handleChange}
                error={formik.touched.activityDuration && Boolean(formik.errors.activityDuration)}
                helperText={formik.touched.activityDuration && formik.errors.activityDuration}
                disabled={status === statusType.REVIEWER}
                inputProps={{
                  style: { color: status === statusType.REVIEWER && '#000' },
                }}
              />
            </Grid>
            <Grid
              item
              sm={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  ابداع یا اختراع دارد؟
                </FormLabel>
                <RadioGroup
                  name="hasInvention"
                  value={formik.values.hasInvention}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="hasInvention"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="hasInvention"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              sm={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  رتبه المپیاد و یا رتبه علمی خاص دارد؟
                </FormLabel>
                <RadioGroup
                  name="hasRank"
                  value={formik.values.hasRank}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="hasRank"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="hasRank"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              sm={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  آثار یا دستاورد در این حوزه دارد؟
                </FormLabel>
                <RadioGroup
                  name="hasAchievement"
                  value={formik.values.hasAchievement}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="hasAchievement"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="hasAchievement"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              sm={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  مربی دارد یا داشته است؟
                </FormLabel>
                <RadioGroup
                  name="hasCoach"
                  value={formik.values.hasCoach}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="hasCoach"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="hasCoach"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              classes={{ root: clsx(classes.item, classes.extraHeight) }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  موفق به کسب مقام شده است؟
                </FormLabel>
                <RadioGroup
                  name="obtainedPosition"
                  value={formik.values.obtainedPosition}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="obtainedPosition"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="منطقه ای"
                  />
                  <FormControlLabel
                    name="obtainedPosition"
                    value="2"
                    control={(<OrangeRadio />)}
                    label="استانی"
                  />
                  <FormControlLabel
                    name="obtainedPosition"
                    value="3"
                    control={(<OrangeRadio />)}
                    label="کشوری"
                  />
                  <FormControlLabel
                    name="obtainedPosition"
                    value="4"
                    control={(<OrangeRadio />)}
                    label="بین المللی"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} classes={{ root: classes.itemMultiline }}>
              <CssTextField
                fullWidth
                variant="outlined"
                name="reason"
                label="دلیل درخواست برای بورس باشگاه پرورش و... را بنویسید"
                multiline
                rows={4}
                value={formik.values.reason}
                onChange={formik.handleChange}
                error={formik.touched.reason && Boolean(formik.errors.reason)}
                helperText={formik.touched.reason && formik.errors.reason}
                disabled={status === statusType.REVIEWER}
                inputProps={{
                  style: { color: status === statusType.REVIEWER && '#000' },
                }}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  آیا تحت حمایت موسسه داخلی یا خارجی است؟
                </FormLabel>
                <RadioGroup
                  name="hasInstituteSupport"
                  value={formik.values.hasInstituteSupport}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="hasInstituteSupport"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="hasInstituteSupport"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              classes={{ root: classes.item }}
            >
              <FormControl
                component="fieldset"
                fullWidth
                style={{ flexDirection: 'row' }}
                disabled={status === statusType.REVIEWER}
              >
                <FormLabel
                  component="legend"
                >
                  آیا تحت حمایت سازمان یا نهاد دولتی هستید؟
                </FormLabel>
                <RadioGroup
                  name="hasOrganizationalSupport"
                  value={formik.values.hasOrganizationalSupport}
                  onChange={formik.handleChange}
                  style={{ flexDirection: 'row' }}
                >
                  <FormControlLabel
                    name="hasOrganizationalSupport"
                    value="0"
                    control={(<OrangeRadio />)}
                    label="خیر"
                  />
                  <FormControlLabel
                    name="hasOrganizationalSupport"
                    value="1"
                    control={(<OrangeRadio />)}
                    label="بله"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} classes={{ root: classes.itemMultiline }}>
              <CssTextField
                fullWidth
                variant="outlined"
                name="description"
                label="توضیحات"
                multiline
                rows={4}
                value={formik.values.description}
                onChange={formik.handleChange}
                error={formik.touched.description && Boolean(formik.errors.description)}
                helperText={formik.touched.description && formik.errors.description}
                disabled={status === statusType.REVIEWER}
                inputProps={{
                  style: { color: status === statusType.REVIEWER && '#000' },
                }}
              />
            </Grid>
            {
              files.map((file, index) => (
                <Grid item xs={12} md={6} classes={{ root: classes.uploadItem }} key={index}>
                  {status === statusType.USER ? (
                    <>
                      <span className={classes.uploadLabel}>{file.label}</span>
                      <label htmlFor={file.id}>
                        <input
                          accept="application/pdf, image/jpg, image/jpeg, image/png, video/mp4"
                          className={classes.inputFile}
                          id={file.id}
                          multiple
                          type="file"
                          onChange={(e) => {
                            formik.setFieldValue([file.id], e.currentTarget.files[0])
                          }}
                          disabled={!Number(formik.values[file.disabled])}
                        />
                        <Button
                          component="span"
                          classes={{ root: classes.uploadButton }}
                          variant="outlined"
                          color="primary"
                          className={classes.button}
                          endIcon={<CloudUploadIcon />}
                          disabled={!Number(formik.values[file.disabled])}
                        >
                          انتخاب فایل
                        </Button>
                      </label>
                      <span className={classes.uploadAttachment}>
                        {formik.values[file.id] && <AttachmentIcon />}
                        {Boolean(formik.errors[file.id])
                      && <ErrorOutlineIcon style={{ color: 'red' }} />}
                      </span>
                    </>
                  ) : formik.values[file.id] && (
                    <Link
                      classes={{ root: classes.link }}
                      variant="body2"
                      // href={IMAGE_BASE_URL + formik.values[file.id]}
                      href={formik.values[file.id]}
                      target="_blank"
                      rel="noopener"
                    >
                      {file.label}
                    </Link>
                  )}
                </Grid>
              ))
            }
            {
              status === statusType.USER && (
              <Grid item xs={12} classes={{ root: classes.buttonContainer }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  classes={{ root: classes.buttonSend }}
                  size="large"
                  disabled={!!loading}
                >
                  ارسال درخواست
                </Button>
              </Grid>
              )
            }
          </Grid>
        </CardContent>
      </Card>
    </form>
  )
}

export default FormStep
